import { HStack, Image, Text } from '@chakra-ui/react'
import React from 'react'
import Arrow from '../../../assets/ai-tutor/arrow.svg'

export default function SummaryLine() {
    return (
        <HStack sx={{
            w: ["100%", "80%"],
            justifyContent: "center",
            alignItems: "center",
            mb: 3
        }}>
            <Image src={Arrow} w={["140px", "180px"]} />
            <Text sx={{
                color: "#130159",
                fontWeight: "500",
                fontSize: "14px",
                lineHeight: "20px"
            }}>
                Summary
            </Text>
            <Image src={Arrow} w={["140px", "180px"]} />
        </HStack>
    )
}
